import React, { useState } from 'react';
import './HomeworkSubmission.css';
import { s3 } from '../../awsConfig'; // Adjust the path as necessary


const HomeworkSubmission = () => {
  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedHomework, setSelectedHomework] = useState('');
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const students = ['Student1', 'Student2', 'Student3'];
  const homeworks = ['Homework1', 'Homework2', 'Homework3', 'Homework4'];

  const handleStudentChange = (e) => {
    setSelectedStudent(e.target.value);
    setSelectedHomework('');
    setFile(null);
    setMessage('');
  };

  const handleHomeworkChange = (e) => {
    setSelectedHomework(e.target.value);
    setFile(null);
    setMessage('');
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('Please select a file to upload');
      return;
    }

    const fileName = `${selectedStudent}/${selectedHomework}/${file.name}`;
    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME, // Ensure this is correctly set
      Key: fileName,
      Body: file,
      ContentType: file.type,
    };

    s3.upload(params, (err, data) => {
      if (err) {
        setMessage(`Error uploading file: ${err.message}`);
      } else {
        setMessage(`File uploaded successfully: ${data.Location}`);
      }
    });
  };

  return (
    <div className="homework-submission">
      <h2>Submit Homework</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Select Student:</label>
          <select value={selectedStudent} onChange={handleStudentChange}>
            <option value="">--Select Student--</option>
            {students.map((student) => (
              <option key={student} value={student}>
                {student}
              </option>
            ))}
          </select>
        </div>

        {selectedStudent && (
          <div>
            <label>Select Homework:</label>
            <select value={selectedHomework} onChange={handleHomeworkChange}>
              <option value="">--Select Homework--</option>
              {homeworks.map((homework) => (
                <option key={homework} value={homework}>
                  {homework}
                </option>
              ))}
            </select>
          </div>
        )}

        {selectedHomework && (
          <div>
            <label>Select File:</label>
            <input type="file" onChange={handleFileChange} />
          </div>
        )}

        {selectedHomework && (
          <button type="submit">Submit</button>
        )}
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default HomeworkSubmission;
